
var timerProductTemplate;
document.addEventListener('DOMContentLoaded', function() {
  document.activeElement.blur();


  
  var productDescriptionTabs = document.querySelectorAll('.product-description__custom h6');
  if (productDescriptionTabs.length > 0) {
    productDescriptionTabs.forEach ((tab, index) => {
      tab.addEventListener('click', function() {
        tab.classList.toggle('active');
      });
    });
  }
  const variantDropdown = document.getElementById('product-dropdown');
  const variantDropdownList = document.getElementById('product-dropdown-options');
  const variantDropdownOptions = document.querySelectorAll('#product-dropdown-options li');
  if (variantDropdown) {
    variantDropdown.addEventListener('click', function() {
      variantDropdownList.classList.toggle("active");
    });
      if (variantDropdownOptions.length > 0) {
        variantDropdownOptions.forEach ((variant, index) => {
          variant.addEventListener('click', function() {
            const dataUrl = this.getAttribute('data-url');
            if (dataUrl) {
              window.location.href = dataUrl;
            }
          });
        });
      }
      document.body.addEventListener("click", function (event) {
      if (!variantDropdown.contains(event.target) && !variantDropdownList.contains(event.target) && variantDropdownList.classList.contains("active")) {
        variantDropdownList.classList.remove("active");
      }
    });
  }
  
  const variantTiles = document.querySelectorAll('.variant-input');
  if (variantTiles.length > 0) {
    variantTiles.forEach ((variant, index) => {
          variant.addEventListener('click', function() {
            const dataUrl = this.getAttribute('data-url');
            if (dataUrl) {
              window.location.href = dataUrl;
            }
          });
        });
  }


  const observer = new MutationObserver(() => {
    document.querySelectorAll('.jdgm-prev-badge').forEach(badge => {
      const textEl = badge.querySelector('.jdgm-prev-badge__text');
      if (textEl && textEl.textContent.includes('Bewertungen')) {
        badge.classList.add('show-badge');
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

});